// extracted by mini-css-extract-plugin
module.exports = {"cluster":"cluster--1ewf7","text":"text--26_pe","icon":"icon--1byyi","hovered":"hovered--1VqvA"};